<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    const baseApi = process.env.VUE_APP_BASE_API || ''
    const swaggerUrl = baseApi.replace(/\/$/, '') + '/swagger'
    window.open(swaggerUrl, '_blank')
    this.$router.back()
  }
}
</script>
